import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { apiRequest } from "../../apiServices/allApi";
const $ = require("jquery");
$.Datatable = require("datatables.net");

const Transactionhistory = () => {
  const Userid = localStorage.getItem("id");
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState();

  //use for pagination..
  let [limit, setLimit] = useState(20);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  //user for searching..
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState("Phone");
  const [findByStatus, setFindByStatus] = useState(0);

  //   searching handler
  const searchHandler = (event) => {
    let key = event.target.value;

    setSearchList(key);
  };
  //   search by status handler
  const searchByStatus = (event) => {
    setSearchType("0");
    let key = event.target.value;
    setFindByStatus(key);
  };

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
  };

  const profle = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/get_txn_deposit/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}`,
        "GET",
        null,
        headers,
      );
      setUser(res.data.admin);
      setNumberOfPages(res.data.totalPages);
    } catch (error) {
      setLoading(false);
    } finally {
    }
  };

  const universalCheckDeposit = (
    payment_gateway,
    order_id,
    referenceId,
    _id,
  ) => {
    if (payment_gateway == "Upigatway") {
      checkupigatewaypay(order_id);
    } else if (payment_gateway == "IMBGATEWAY") {
      console.log(order_id,'order_idorder_idorder_idorder_id')
      checkImbGatewaypay(order_id);
    } else {
      alert("Nothing found");
    }
  };

  const checkupigatewaypay = async (order_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `depositupipay/check_status`,
        "POST",
        { order_id },
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      Swal.fire({
        text: res.data?.msg,
        icon: "success",
      });
      profle();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
    }
  };
  const checkImbGatewaypay = async (order_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `imb/check_status/${order_id}`,
        "GET",
        headers,
      );
   
      Swal.fire({
        text: res.data?.msg,
        icon: "success",
      });
      profle();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
    }
  };
  // check in

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };

  const newdateFormat = (e) => {
    let today = new Date(e);
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();
    today = dd + "-" + mm + "-" + yyyy;
    return today;
  };

  useEffect(() => {
    profle();
  }, [pageNumber, limit, searchList, searchType, findByStatus]);

  if (user == undefined) {
    return null;
  }

  return loading ? null : (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className="row mt-4">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body p-2">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="dashboard_heading m-0 text-primary">
                  <i className="mdi mdi-receipt text-primary mr-2"></i> Deposit
                  & Payment History
                </h4>
                <span className="badge badge-primary px-3 py-2">Ledger</span>
              </div>

              {/* searching */}
              <div className="admin-filter-bar">
                <select
                  className="form-control"
                  style={{ maxWidth: "180px" }}
                  id="searchType"
                  name="searchtype"
                  onChange={(e) => setSearchType(e.target.value)}
                >
                  <option value="Phone">Search by Phone</option>
                  <option value="Name">Search by Name</option>
                  <option value="_id">Search by Txn ID</option>
                </select>

                <input
                  type="text"
                  placeholder="Search keyword..."
                  className="form-control"
                  style={{ flex: "1", minWidth: "180px" }}
                  onChange={searchHandler}
                />

                <select
                  className="form-control"
                  style={{ maxWidth: "170px" }}
                  id="findByStatus"
                  name="findByStatus"
                  onChange={searchByStatus}
                >
                  <option value="0">Filter by Status</option>
                  <option value="PAID">PAID</option>
                  <option value="Pending">Pending</option>
                  <option value="FAILED">FAILED</option>
                  <option value="checkin">Checkin</option>
                </select>

                <select
                  className="form-control"
                  id="pagelimit"
                  name="pagelimit"
                  value={limit}
                  onChange={setpageLimit}
                >
                  <option value="10">10 / page</option>
                  <option value="20">20 / page</option>
                  <option value="50">50 / page</option>
                  <option value="100">100 / page</option>
                  <option value="500">500 / page</option>
                </select>
              </div>

              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      {Userid == "67f8f9731bb8e80965dd62b8" ? <th> ID</th> : ""}
                      <th> Phone</th>
                      <th> User</th>
                      {Userid == "67f8f9731bb8e80965dd62b8" ? (
                        <th> R_orderId</th>
                      ) : (
                        ""
                      )}
                      <th> Amount </th>
                      <th> Status </th>
                      <th> Gateway </th>
                      <th> Action </th>
                      <th> Action By </th>
                      <th> Date </th>
                    </tr>
                  </thead>

                  <tbody>
                    {user &&
                      user.map((data, key) => {
                        return (
                          <tr>
                            <td>{key + 1}</td>

                            <td>
                              {localStorage.getItem("user") === "Admin" ||
                              localStorage.getItem("updateLegalData") ===
                                "true" ? (
                                <span className="pl-2">
                                  {data.User_id ? data.User_id.Phone : ""}
                                </span>
                              ) : (
                                <span className="pl-2">{`${
                                  "********" +
                                  data.User_id.Phone.toString().slice(-2)
                                }`}</span>
                              )}
                            </td>
                            <td>
                              {data.User_id && (
                                <Link
                                  className="btn btn-sm btn-outline-info"
                                  to={`/user/view_user/${data.User_id._id}`}
                                >
                                  {data.User_id.Name}
                                </Link>
                              )}
                            </td>

                            <td>{data.amount}</td>
                            <td className="font-weight-bold text-success">
                              {data.status}
                            </td>
                            <td>{data.payment_gateway}</td>

                            <td>
                              {data.status != "PAID" &&
                              data.status != "SUCCESS" &&
                              data.status != "FAILED" ? (
                                <button
                                  className="btn btn-danger" style={{fontSize: '12px'}}
                                  onClick={() =>
                                    universalCheckDeposit(
                                      data.payment_gateway,
                                      data.order_id,
                                      data?.referenceId,
                                      data._id,
                                    )
                                  }
                                >
                                  Check {data.payment_gateway}
                                </button>
                              ) : (
                                "Checked All "
                              )}

                              {}
                            </td>
                            <td className="font-weight-bold text-success">
                              {data?.action_by?.Name ?? "----"}
                            </td>
                            <td>{dateFormat(data.createdAt).split(",")[0]} </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              <div className="mt-4">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Transactionhistory;
